'use client';

import { Component, ErrorInfo, ReactNode } from 'react';

import { IS_VERCEL_PROD } from '@monoimin/constants';

import { trackError } from './utils';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  errorInfo?: ErrorInfo;
  errorMsg?: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
    errorMsg: '',
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    trackError(error, errorInfo);
    this.setState({ errorMsg: error.message, errorInfo, hasError: true });
  }

  public override render() {
    if (this.state.hasError) {
      return IS_VERCEL_PROD ? null : (
        <div className='mx-auto container'>
          <h1>Sorry.. there was an error </h1>
          <p className='text-red font-bold'>{this.state.errorMsg}</p>
        </div>
      );
    }

    return this.props.children;
  }
}
